import { DateTime } from 'luxon';
class DateTimeUtils {
    static dateTimeGMTStart(input: Date | undefined): Date {
        if(typeof input === 'undefined' || input === null) {
            input = new Date();
        }
        const dateNow = input;
        dateNow.setHours(0, 0, 0, 0);

        dateNow.setTime(dateNow.getTime() - dateNow.getTimezoneOffset() * 60 * 1000);
        input.setHours(dateNow.getHours(), dateNow.getMinutes(), dateNow.getSeconds());

        return input;
    }

    static dateTimeGMTEnd(input: Date | undefined): Date {
        if(typeof input === 'undefined' || input === null) {
            input = new Date();
        }
        const dateNow = input;
        dateNow.setHours(23, 59, 59);
        dateNow.setTime(dateNow.getTime() - dateNow.getTimezoneOffset() * 60 * 1000);
        input.setHours(dateNow.getHours(), dateNow.getMinutes(), dateNow.getSeconds());

        return input;
    }

    static startDateTimeWithTimeZone(input: Date | undefined): any {
        if(typeof input === 'undefined' || input === null) {
            return null;
        }
        const dateTime = DateTime.fromJSDate(input, {
            zone: 'Europe/Oslo'
        }).set({
            hour: 0,
            minute: 0,
            second: 0,
            millisecond: 0
        });

        return dateTime.toISO();
    }

    static endDateTimeWithTimeZone(input: Date | undefined): any {
        if(typeof input === 'undefined' || input === null) {
            return null;
        }
        const dateTime = DateTime.fromJSDate(input, {
            zone: 'Europe/Oslo'
        }).set({
            hour: 23,
            minute: 59,
            second: 59,
            millisecond: 0
        });

        return dateTime.toISO();
    }
}

export default DateTimeUtils;